// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"994720b9","95":"fd68696b","213":"8f935104","262":"657f4939","282":"661fecf0","322":"85d71e42","458":"d29bd734","709":"d2db7dac","787":"7bca77fe","790":"7860a7c0","928":"344399ba","935":"1d9d4964"}[chunkId] + ".chunk.js";
};